import { Routes } from '@angular/router';

import { roleGuard } from '../../core/guards/role.guard';
import { RoleCode } from '../../shared/models/user/user.enums';

export const warehousesRoutes: Routes = [
	{
		path: 'warehouses',
		canMatch: [roleGuard],
		data: { allowedRoles: [RoleCode.ADMIN, RoleCode.SUPER_ADMIN] },
		children: [
			{
				path: '',
				loadComponent: () => import('./pages/warehouses-page/warehouses-page.component').then(c => c.WarehousesPageComponent)
			}
		]
	}
];
